const FALLBACK_NAME = "yt video";

// The media row is named after the YouTube video id (`?v=`) so it stays
// readable in the asset lists; anything unparsable gets a generic name.
export function getYoutubeMediaName(url: string | null | undefined): string {
  try {
    return new URL(url ?? "").searchParams.get("v") ?? FALLBACK_NAME;
  } catch {
    return FALLBACK_NAME;
  }
}
